/**
 * Manual §3 in-game faction-pick ceremony (frontend AI).
 *
 * Mirrors the backend Fossa _choose_faction handler: when the seat's
 * faction is pre-assigned (today's lobby path) auto-confirm with
 * `commitFactionChoice(faction_id)`; when null (post-CC_LOBBY), pick
 * the first unclaimed faction.
 *
 * The ceremony is clockwise from Player One — engine advances
 * `game.current_player` one seat at a time, so this handler must
 * wait for its own turn (mirrors AIInitialLodging).
 */
export default function artificialChooseFaction(
        gamePlayerController, aiPackage) {
    const gamePlayer = gamePlayerController.gamePlayerData;
    const game = gamePlayerController.game;
    const gameData = game && game.gameData;
    const isActiveSeat =
        gameData && gameData.current_player === gamePlayer.id;
    aiPackage.success = true;
    if (!isActiveSeat) {
        aiPackage.addToMessage(
            'Waiting for my turn in the faction ceremony.');
        return;
    }
    let factionId = gamePlayer.faction;
    if (factionId === null || factionId === undefined) {
        const claimed = new Set();
        const seats = (gameData && gameData.gameplayer_set) || [];
        for (const seat of seats) {
            if (!seat) continue;
            if (seat.id === gamePlayer.id) continue;
            if (seat.faction) claimed.add(seat.faction);
        }
        for (let candidate = 1; candidate <= 6; candidate += 1) {
            if (!claimed.has(candidate)) {
                factionId = candidate;
                break;
            }
        }
        if (factionId === null || factionId === undefined) {
            // Defensive floor: every faction claimed. Unreachable at <= 6 seats
            // (6 factions, this seat excluded from `claimed`, so always >= 1
            // unclaimed), but never commit null here -- commitFactionChoice(null)
            // is the API's "auto-confirm my pre-assigned faction" signal, and
            // this seat's faction is already null, so it would stall. Emit a
            // real faction id; the engine's validate-first + reject-retry net is
            // the backstop (HSH_STYLE AI always-act: legal beats optimal).
            factionId = 1;
        }
    }
    aiPackage.addProvenance(
        'Which faction should I commit?',
        `Faction ${factionId}`,
        'Auto-confirm pre-assigned faction; pick first unclaimed if null.');
    aiPackage.addToMessage(`Choose Faction - faction ${factionId}.`);
    if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.commitFactionChoice(factionId);
    }
}
